import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import type { FC } from "react";

import { RichTooltip } from "~/components/UI/RichTooltip";
import { keepClickInside } from "~/utils/stopPropagation";

import * as Styled from "./SettledElsewhereMark.styles";

interface ISettledElsewhereMarkProps {
  tooltip: string;
}

export const SettledElsewhereMark: FC<ISettledElsewhereMarkProps> = ({
  tooltip,
}) => (
  <RichTooltip title={tooltip}>
    <Styled.Mark aria-label={tooltip} onClick={keepClickInside}>
      <WarningAmberRoundedIcon />
    </Styled.Mark>
  </RichTooltip>
);
